module.exports = __webpack_public_path__ + "static/media/ic_categories_collection.2ffb8800.svg";